/**
 * Placeholder Colors Utility
 * Returns color theme configuration for different placeholder types
 *
 * `default` is the accent/border color, `hover` is the background fill.
 * When `isDarkMode` is true, backgrounds are low-opacity versions of the
 * accent so they sit well on dark surfaces, and text uses the accent color
 * directly for contrast.
 *
 * Migrated from vardogyir-ui/PlaceholderColors.js
 */

import useThemeStore, { resolveMode } from '../stores/useThemeStore';

const COLORS = {
  text:             { default: '#7AC0F8', hover: '#D7ECFD', hoverDark: 'rgba(122,192,248,0.18)', textDark: '#93ccfa', icon: '/svgs/format_size_icon.svg' },
  number:           { default: '#ED6696', hover: '#FAD1DF', hoverDark: 'rgba(237,102,150,0.18)', textDark: '#f08aaf', icon: '/svgs/pin_icon.svg' },
  list:             { default: '#55A77A', hover: '#CCE5D7', hoverDark: 'rgba(85,167,122,0.18)',  textDark: '#6dbf91', icon: '/svgs/data_array_icon.svg' },
  image:            { default: '#FFB74D', hover: '#FFE9CA', hoverDark: 'rgba(255,183,77,0.18)',  textDark: '#ffc26a', icon: '/svgs/format_size_icon.svg' },
  datetime:         { default: '#B782EC', hover: '#F1E6FB', hoverDark: 'rgba(183,130,236,0.18)', textDark: '#c99af0', icon: '/svgs/calendar_month.svg' },
  form_placeholder: { default: '#2670FF', hover: '#D9E7FD', hoverDark: 'rgba(38,112,255,0.18)', textDark: '#5f96ff', icon: '/svgs/form_placeholder_icon.svg' },
  html:             { default: '#E44D26', hover: 'rgba(228,77,38,0.15)', hoverDark: 'rgba(228,77,38,0.20)', textDark: '#ef7a5c', icon: '/svgs/html_icon.svg' },
  global:           { default: '#9B59B6', hover: '#E8D5F2', hoverDark: 'rgba(155,89,182,0.18)', textDark: '#b87fd4', icon: '/svgs/data_array_icon.svg' },
};

const DEFAULT_COLORS = COLORS.text;

export const AGENT_MENTION_COLORS = {
  bg: '#ede9fe',
  bgDark: 'rgba(139, 92, 246, 0.18)',
  border: '#8b5cf6',
  text: '#6d28d9',
  textDark: '#a78bfa',
};

function detectDarkMode() {
  try {
    return resolveMode(useThemeStore.getState().preference) === 'dark';
  } catch {
    return false;
  }
}

const getPlaceholderColors = (type, data_length, isDarkMode) => {
  if (isDarkMode === undefined) {
    isDarkMode = detectDarkMode();
  }
  const entry = COLORS[type] || DEFAULT_COLORS;
  return {
    default: entry.default,
    hover: isDarkMode ? entry.hoverDark : entry.hover,
    text: isDarkMode ? entry.textDark : undefined,
    icon: entry.icon,
  };
};

export default getPlaceholderColors;
